
import _ from 'underscore';
import { useMemo, useCallback, useEffect, useContext } from 'react';
import { ServerContext } from '@bingads-webui-campaign-react/server-context';
import { useCustomerLevelVariables, usePostponeReadVariables } from '@bingads-webui-campaign-react/basic-context-utils';
import { useCurrencies } from '@bingads-webui/overreact-cc';
import { DefaultCurrencyCode } from '@bingads-webui-campaign-react/promotion-offers';
import { Constants } from '@bingads-webui-clientcenter/entity-utils';
import { isProdEnvironment } from '@bingads-webui-campaign/campaign-ui-common';

export const PMaxLiteSignupWizardCouponClassForNonProd = 'ATESTCOUPONCLASSXIAOHUL01'; // for non-product

// TODO: add prod backup coupon for pmax-lite-signup, waiting for PM
export const PMaxLiteSignupWizardCouponClassForProd = ''; // for product

export const PMaxLiteSignupWizardCouponDetails = {
  // for non-product
  ATESTCOUPONCLASSXIAOHUL01: {
    ClassName: 'ATESTCOUPONCLASSXIAOHUL01',
    CouponPurposeId: 0,
    CouponTypeId: 3,
    CouponValue: 100,
    CurrencyId: 12,
    EndDate: '2026-08-01T00:00:00.0000000',
    ExpiryDate: '2026-08-01T00:00:00.0000000',
    ExpiryDateFromAssociation: '0001-01-01T00:00:00.0000000',
    LimitForDaysToUseFromCustomerCreation: 30,
    MaxRedemptionCount: 1,
    MaxRedemptionPerAccountCount: 1,
    PercentOff: null,
    StartDate: '2023-11-01T00:00:00.0000000',
    UpfrontSpending: 25,
    id: 1243216625,
  },
};

export const useBackupCoupon = () => {
  const isProd = isProdEnvironment(window.location.host);
  const backupCouponClass = isProd ? PMaxLiteSignupWizardCouponClassForProd : PMaxLiteSignupWizardCouponClassForNonProd;

  const backupCouponDetailsConstant = useMemo(() => (
    PMaxLiteSignupWizardCouponDetails[backupCouponClass]
  ), [backupCouponClass]);

  return {
    backupCouponClass,
    backupCouponDetailsConstant,
  };
};

export const useGetCouponCurrencyCode = () => {
  const serverContext = useContext(ServerContext);
  const { CurrentAccount } = serverContext;
  const customerLevelVariables = useCustomerLevelVariables();
  const postponeReadConfig = usePostponeReadVariables();
  const [{ data: currencies, error }, { read }] = useCurrencies(customerLevelVariables, postponeReadConfig);

  useEffect(() => {
    if (!currencies && !error && CurrentAccount) {
      read();
    }
  }, [CurrentAccount, currencies, error, read]);

  const getCouponCurrencyCodeFn = useCallback((couponCurrencyId) => {
    if (currencies && !_.isUndefined(couponCurrencyId) && !_.isNull(couponCurrencyId)) {
      const currency = _.findWhere(currencies, { id: couponCurrencyId.toString() });
      return _.get(currency, ['value', 'Code'], DefaultCurrencyCode);
    }
    return DefaultCurrencyCode;
  }, [currencies]);

  return getCouponCurrencyCodeFn;
};

export const useCouponOfferText = (couponDetails, i18n) => {
  const couponText = useMemo(() => {
    if (couponDetails && couponDetails.CouponPurposeId === Constants.CouponPurposeId.StoreAds) {
      return i18n.getString(_TL_('This offer only applies to the amount you spend on your Microsoft Store ads campaigns.'));
    }
    return null;
  }, [couponDetails, i18n]);
  return couponText;
};

